import React from "react";

class ApActionButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const classes =
      "ApActionButton" +
      (this.props.active ? " ApActionButton-Active" : "") +
      (this.props.color ? ` ApColor-${this.props.color}` : "");
    return (
      <div>
        <button
          data-tip={this.props.description}
          className={classes}
          onClick={() => this.props.onClick()}
        >
          {this.props.children}
        </button>
      </div>
    );
  }
}

export default ApActionButton;



// WEBPACK FOOTER //
// ./src/components/approval/ApActionButton.js